import {
  IonContent,
  IonDatetime,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DateProps } from "../../models/Data";
import "./Date.scss";

const InputDate: React.FC<any> = ({
  onCloseModal,
  initialData,
  isOpen,
  min,
}: DateProps) => {
  const [date, setDate] = useState<string | null>(initialData || null);
  const { t } = useTranslation(["general"]);

  const handleDateChange = (event: CustomEvent) => {
    setDate(event.detail.value);
    onCloseModal(event.detail.value);
  };

  useEffect(() => {
    setDate(initialData || null);
  }, [isOpen, initialData]);

  return (
    <IonContent className="ion-no-padding ion-no-margin input-date">
      <IonDatetime
        presentation="date"
        size="cover"
        showDefaultTitle={true}
        showDefaultButtons={true}
        showClearButton={true}
        onIonChange={handleDateChange}
        value={date || ""}
        display-format="YYYY-MM-DD"
        locale={"id-ID"}
        doneText={t("submit")}
        cancelText={t("cancel")}
        clearText="Clear"
        color={"danger"}
        min={min ?? ""}
      >
        <span slot="title">{`${t("select")} ${t("date")}`}</span>
      </IonDatetime>
    </IonContent>
  );
};

export default InputDate;
